import { merchantInstance } from "@/axios-path.js";

// Auto Transfer Store Transfer Config per district
export default {
    namespaced: true,
    state: {
        loading: false,
        error: null,
        config: null,
    },
    mutations: {
        setLoading(state, v) {
            state.loading = !!v;
        },
        setError(state, e) {
            state.error = e || null;
        },
        setConfig(state, cfg) {
            state.config = cfg || null;
        },
    },
    actions: {
        async getByDistrict({ commit }, { district_id }) {
            commit("setLoading", true);
            commit("setError", null);
            try {
                if (!district_id) throw new Error("district_id is required");
                const res = await merchantInstance.get(
                    "/api/v1/merChant/AutoTransfer/StoreTransferConfig",
                    {
                        params: { district_id },
                        headers: { "X-App-Client": "weserve_backoffice" },
                    }
                );
                // res may be { msg, data } or plain data depending on interceptor
                let data = null;
                if (res && res.msg && res.data) data = res.data;
                else if (res && res.data) data = res.data;
                else if (res && res.id) data = res; // already unwrapped

                if (!data) {
                    // Not found: keep null config
                    commit("setConfig", null);
                    return null;
                }
                commit("setConfig", data);
                return data;
            } catch (e) {
                // 404 or validation: treat as no config
                commit("setError", e);
                commit("setConfig", null);
                return null;
            } finally {
                commit("setLoading", false);
            }
        },
        async patch({ commit }, payload) {
            commit("setLoading", true);
            commit("setError", null);
            try {
                if (!payload || !payload.district_id)
                    throw new Error("district_id is required for PATCH");
                const res = await merchantInstance.patch(
                    "/api/v1/merChant/AutoTransfer/StoreTransferConfig",
                    payload,
                    {
                        headers: {
                            "X-App-Client": "weserve_backoffice",
                            "Content-Type": "application/json",
                        },
                    }
                );
                let data = null;
                if (res && res.msg && res.data) data = res.data;
                else if (res && res.data) data = res.data;
                else if (res && res.id) data = res;
                commit("setConfig", data);
                return data;
            } catch (e) {
                commit("setError", e);
                return false;
            } finally {
                commit("setLoading", false);
            }
        },
    },
    getters: {
        config: (s) => s.config,
        loading: (s) => s.loading,
        error: (s) => s.error,
    },
};
